import React from 'react';
import { HeadingWizard } from '../../components';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface SideSheetHeaderProps {
  children?: React.ReactNode;
  title: string;
  onCloseClick: () => void;
  showDefault: boolean;
  subtitle?: string;
}

const SideSheetHeader: React.FC<Partial<SideSheetHeaderProps>> = ({
  children,
  title = '',
  subtitle,
  onCloseClick = () => {},
  showDefault = true,
}) => {
  if (showDefault) {
    return (
      <div className="flex h-12 items-center justify-between border-b border-slate-200/80 bg-slate-50/70 px-4 py-2 backdrop-blur-xs">
        <div className="flex flex-col gap-0.5">
          {title && (
            <HeadingWizard addOnClass="text-base font-bold tracking-tight text-slate-900">
              {title}
            </HeadingWizard>
          )}
          {subtitle && (
            <span className="text-xs font-medium text-slate-500">
              {subtitle}
            </span>
          )}
        </div>
        <button
          type="button"
          aria-label="Close side sheet"
          onClick={onCloseClick}
          className="inline-flex size-7 items-center justify-center rounded-full text-slate-400 transition-colors hover:bg-slate-200/80 hover:text-slate-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400 cursor-pointer"
        >
          <XMarkIcon className="size-4 stroke-[2.25px]" />
        </button>
      </div>
    );
  }
  return <>{children}</>;
};

export default SideSheetHeader;
